<template>
  <div
    class="flex flex-col bg-gray-700 text-white h-full fixed left-0 top-0"
  >
    <div class="h-full w-full">
      <ul>
        <li
          class="p-2 text-center border-b border-gray-600 text-sm font-semibold"
        >
          <router-link to="/companies">Företag</router-link>
        </li>
        <li
          class="p-2 text-center border-b border-gray-600 text-sm font-semibold"
        >
          <router-link to="/products">Produkter</router-link>
        </li>
        <li
          class="p-2 text-center border-b border-gray-600 text-sm font-semibold"
        >
          <router-link to="/cashregisters">Kassaregister</router-link>
        </li>
        <li
          class="p-2 text-center border-b border-gray-600 text-sm font-semibold"
        >
          <router-link to="/reports">Rapporter</router-link>
        </li>
        <li
          class="p-2 text-center border-b border-gray-600 text-sm font-semibold"
        >
          <router-link to="/messages">Meddelanden</router-link>
        </li>
      </ul>
    </div>
    <div class="h-24 flex justify-center items-center">
      <button @click="logout">Logga ut</button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  methods: {
    ...mapActions('auth', ['logout']),
  },
}
</script>

<style lang="scss" scoped></style>
